////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/////////STYLED/////////
const ImageTOBase64 = styled.img`
	max-width: ${(props) => props.width + 'px'};
	box-sizing: border-box;
	cursor: ${(props) => (props.cursor ? '' : 'pointer')};
`
/////////STYLED/////////

/**
 *
 * 2 layout possible
 * if noAction create img with onClick disabled
 * else is use for flag to change language
 *
 * @param base64        img on base64
 * @param width         with off img
 * @param height        heigth off img
 * @param idElem        id off element clic
 * @param click         action on clic
 * @param scope         target for language
 * @param noAction      bool to switch languages or just decode
 * @param noPointer
 * @returns {*}
 * @constructor
 */
function Base64Images({ base64, width, _height, idElem, click, scope, noAction, noPointer }) {
	const srcData = `data:image/png;base64, ${base64}`

	///////////////////////////////// RENDER ///////////////////////////////////////

	return !noAction ? (
		<ImageTOBase64 onClick={() => click(idElem, scope)} src={srcData} width={width} />
	) : (
		<ImageTOBase64 src={srcData} width={width} cursor={noPointer} />
	)
}

Base64Images.propTypes = {
	base64: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
	idElem: PropTypes.number,
	click: PropTypes.func,
	scope: PropTypes.string,
	noAction: PropTypes.bool,
}

export default Base64Images
